/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * DesignIcon
 */
export default class DesignIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M18 1a2 2 0 012 2v9c0 .088-.006.174-.017.259A1.997 1.997 0 0121 14v2a2 2 0 01-2 2h-4v3a2 2 0 01-2 2h-2a2 2 0 01-2-2v-3H5a2 2 0 01-2-2v-2a2 2 0 011.017-1.742A1.91 1.91 0 014 12V3a2 2 0 012-2h12zm1 13H5v2h5a1 1 0 011 1v4h2v-4a1 1 0 011-1h5v-2zM7.5 3H6v9h12V3h-4.5v3a1 1 0 01-2 0V3h-2v6a1 1 0 11-2 0V3z"/><g fillRule="evenodd"><use/><use fillRule="nonzero"/></g></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

